import { styled } from '@linaria/react'

export const RadarBlockWrapper = styled.div`
  background: white;
  border-radius: 5px;
  box-shadow: 0px 4px 22px rgba(0, 0, 0, 0.25);
  padding: 4rem !important;

  display: flex;
  flex-direction: column;

  @media screen and (max-width: 640px) {
    padding: 2rem 1rem !important;
  }

  > .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 2rem;
    flex-direction: column;
    gap: 4rem;

    @media screen and (min-width: 960px) {
      flex-direction: row;
      gap: 0;
    }

    > * {
      flex: 1;
    }
  }

  h2 {
    color: var(--primary);
    padding: 0;
    margin-bottom: 2.2rem;

    mark {
      background: none;
    }
  }

  #chart {
    --fill-inactive: #ebeaeb;
    --fill-active: #004775;
    --fill-filler: #f2f2f2;
    width: 100%;
    height: auto;

    path {
      fill: var(--fill-inactive);
      outline: none;
      transition: fill 0.4s ease;

      &[data-active='true'] {
        fill: var(--fill-active);
      }

      &.filler {
        fill: var(--fill-filler);
      }

      &.spacer {
        fill: #fff;
      }
    }

    g[id^='_x'],
    path[id^='_x'] {
      pointer-events: none;
    }

    #industry-activity,
    #infrastructure,
    #technology,
    #regulation,
    #customer-interest {
      g:not([id^='_x']) path:not(.filler, .spacer):hover {
        fill: var(--fill-active);
        cursor: pointer;
      }
    }

    #circle-inner {
      fill: #fff;
    }

    #circle-outer {
      fill: var(--fill-active);
    }

    g[id^='icon'] {
      path,
      rect {
        fill: var(--fill-active);
      }
    }

    .label {
      opacity: 0.5;
      transition: opacity 0.4s ease;

      &[data-active='true'] {
        opacity: 1;
      }

      path {
        fill: var(--fill-active);
      }
    }
  }

  .spacer-decor {
    flex: unset;
    padding-inline: 4rem;
    display: none;

    @media screen and (min-width: 960px) {
      display: block;
    }
  }

  .segment-details {
    display: grid;
    grid-template-areas: 'stack';

    .segment-details--item {
      grid-area: stack;
      opacity: 0;
      transition: all 0.4s ease;
      transform: translateX(-5px);
      visibility: hidden;

      &[data-active='true'] {
        opacity: 1;
        transition-delay: 0.2s;
        transform: translateX(0);
        visibility: visible;
      }

      h2 {
        font-size: var(--font-size-body);
        margin-bottom: 1rem;
      }

      p {
        color: var(--primary);
        margin-bottom: 2rem;
      }

      .cta > a {
        background: var(--primary);
        border-radius: 999px;
        display: inline-block;
        font-size: 18px;
        font-weight: var(--font-weight-bold);
        padding: 10px 32px;
        text-decoration: none;
      }

      .cta a {
        color: white;
        text-decoration: none;
      }

      img {
        height: 70px;
      }
    }
  }

  .button-controls {
    align-self: flex-end;
    display: flex;
    gap: 1rem;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-color: var(--black);
      transition: 0.3s ease;
      fill: var(--white);
      margin: 5px;

      &:hover {
        opacity: 0.75;
      }

      svg {
        width: 13px;
        vertical-align: middle;
      }

      &.button-controls--prev svg {
        transform: rotate(-180deg);
      }
    }
  }

  .radar-tooltip {
    color: var(--white);
    background-color: var(--deep-blue);
    font-size: 0.75rem;
    max-width: 400px;

    &__title {
      color: var(--secondary);
    }

    &__score {
      color: var(--secondary);
    }

    p {
      line-height: 1.6;
      margin-top: 0;
      margin-bottom: 6px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
`
